import { Download } from 'lucide-react';
import { usePWAInstall } from '@/hooks/usePWAInstall';

export function PWAInstallButton() {
  const { canInstall, isInstalled, handleInstallClick } = usePWAInstall();

  if (isInstalled) {
    return null; // Don't show button if app is already installed
  }

  if (!canInstall) {
    return null; // Don't show button if install prompt is not available
  }

  return (
    <button
      onClick={handleInstallClick}
      className="inline-flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
      title="Install HEasy Q&A as an app"
    >
      <Download size={16} />
      Installa App
    </button>
  );
}